import React, { useCallback, useEffect, useState } from "react";
import { Container, Col, Row, Form, InputGroup, FormFloating } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { showAlert } from "../../redux/slices/alertSlice";
import { insertProject } from "../../redux/slices/projectSlice";

import "../../assets/css/forms.css";
import ducksGroupImg from "../../assets/images/ducksGroup.svg";
import { ChevronLeftIcon } from "../../components/Icon/icons";
import IconButton from "../../components/IconButton/IconButton";
import ButtonSpinner from "../../components/UI/ButtonSpinner/ButtonSpinner";
import FormAlert from "../../components/UI/FormAlert/FormAlert";
import Subheader from "../../components/UI/Subheader/Subheader";

function ProjectScreen() {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [name, setName] = useState("");

  const dispatch = useDispatch();
  const projectSlice = useSelector((state) => state.projectSlice);

  const navigate = useNavigate();
  const goToHome = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const handleShowAlert = useCallback(
    (alert) => {
      dispatch(showAlert(alert));
    },
    [dispatch]
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch(insertProject({ name }));
    setIsSubmitted(true);
  };

  useEffect(() => {
    const canRedirect = isSubmitted && !projectSlice.loading && !projectSlice.error;
    if (canRedirect) {
      handleShowAlert({
        headingText: "Projeto cadastrado!",
        text: "Projeto cadastrado com sucesso!",
      });
      goToHome();
    }
  }, [
    dispatch,
    goToHome,
    handleShowAlert,
    isSubmitted,
    projectSlice.error,
    projectSlice.loading,
    projectSlice.projectList,
  ]);

  return (
    <>
      <Helmet>
        <title>Projetos</title>
      </Helmet>
      <Subheader title="Projeto | Cadastro de Projeto"></Subheader>

      <Container>
        <Row className="mb-3">
          <Col className="screen-header">
            <IconButton onClick={goToHome} className="icon-button-return">
              <ChevronLeftIcon />
            </IconButton>
            <h4 className="screen-header-title">Adicionar Projeto</h4>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="registration-form">
              <h4>Adicionar dados</h4>

              <p>Insira abaixo o nome do projeto para completar o cadastro</p>

              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="projectName" className="mb-3">
                  <FormFloating>
                    <Form.Label>Nome do Projeto</Form.Label>
                    <InputGroup>
                      <Form.Control
                        required
                        placeholder="Nome do projeto"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </InputGroup>
                  </FormFloating>
                </Form.Group>

                <ButtonSpinner type="submit" isLoading={projectSlice.loading}>
                  Cadastrar Projeto
                </ButtonSpinner>
              </Form>
            </div>

            {projectSlice.error && <FormAlert alertTextList={projectSlice.error} />}
          </Col>
          <Col className="d-flex align-items-center">
            <img style={{ width: "100%", maxWidth: "450px" }} src={ducksGroupImg} alt="Ilustração" />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ProjectScreen;
